// src/components/Activities/Objectives.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import './Activities.css';

const Objectives = () => {
    const objectives = [
        {
            id: 1,
            icon: '🌍',
            image: 'https://images.unsplash.com/photo-1531482615713-2afd69097998?w=600',
            title: 'Foster Strategic Implementation of Global Climate Goals',
            description: `Facilitate high-level discussions to develop actionable strategies for the realization of the United Nations Framework Convention on Climate Change (UNFCCC) objectives. The Summit will also focus on institutionalizing the outcomes of COP29 (Baku, Azerbaijan), including TNC's three core priorities, while aligning efforts with the Sustainable Development Goals (SDGs).`
        },
        {
            id: 2,
            icon: '💰',
            image: 'https://images.unsplash.com/photo-1543286386-713bdd548da4?w=600',
            title: 'Accelerate Investment in Africa\'s Emerging Opportunities',
            description: `Unite governments, institutional investors, and private stakeholders to explore and capitalize on Africa's vast $12 trillion investment potential across key sectors, including infrastructure, green energy transition, climate change, blue economy, digital economy, and artificial intelligence (AI).`
        },
        {
            id: 3,
            icon: '🤝',
            image: 'https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=600',
            title: 'Mobilize Global Resources for Africa\'s Development',
            description: `Attract global funding to support Africa's continental, regional, and national infrastructure projects, renewable energy initiatives, and industrialization strategies, ensuring alignment with the African Continental Free Trade Agreement (AfCFTA) objectives.`
        },
        {
            id: 4,
            icon: '🛡️',
            image: 'https://images.unsplash.com/photo-1504384308090-c894fdcc538d?w=600',
            title: 'Evaluate and Enhance Economic and Security Infrastructure',
            description: `Provide a comprehensive platform to assess Africa's economic and security infrastructure needs. Identify and engage new development partners to mobilize resources for Africa's accelerated development and stability.`
        },
        {
            id: 5,
            icon: '📊',
            image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=600',
            title: 'Facilitate Trade and Export Partnerships',
            description: `Promote the development of sustainable trade partnerships while creating export and import opportunities that bolster Africa's integration into global markets.`
        },
        {
            id: 6,
            icon: '🏗️',
            image: 'https://images.unsplash.com/photo-1541888946425-d81bb19240f5?w=600',
            title: 'Showcase Africa\'s Investment Opportunities',
            description: `Offer a high-visibility platform for presenting African infrastructure development projects, highlighting investment opportunities to attract international investors.`
        },
        {
            id: 7,
            icon: '🏛️',
            image: 'https://images.unsplash.com/photo-1591509509435-b45b8bac9b3f?w=600',
            title: 'Strengthen Government Commitment to Infrastructure Development',
            description: `Inspire increased governmental action and policy frameworks to advance infrastructure development as a catalyst for achieving climate change objectives in Africa.`
        },
        {
            id: 8,
            icon: '💼',
            image: 'https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=600',
            title: 'Empower MSMEs and Foster Economic Diversification',
            description: `Promote entrepreneurial capacity-building initiatives and the identification of high-potential Micro, Small, and Medium Enterprises (MSMEs) across Africa. Attract local and foreign direct investment to diversify economies in alignment with zero-oil initiatives and sustainable growth strategies.`
        }
    ];

    return (
        <div className="activity-page">
            {/* Hero Section */}
            <div className="activity-hero">
                <div className="activity-hero-overlay"></div>
                <div className="activity-hero-content">
                    <span className="activity-hero-badge">OBJECTIVES</span>
                    <h1>Summit Objectives</h1>
                    <p>
                        AICIS 2026 is driven by a clear set of objectives aimed at advancing Africa's
                        infrastructure development, climate action, and sustainable economic growth.
                    </p>
                </div>
            </div>

            {/* Objectives Content */}
            <div className="activity-container">
                <div className="objectives-grid">
                    {objectives.map((obj) => (
                        <div className="objective-card" key={obj.id}>
                            <div className="objective-image-wrapper">
                                <img
                                    src={obj.image}
                                    alt={obj.title}
                                    className="objective-image"
                                    loading="lazy"
                                />
                                <div className="objective-image-overlay">
                                    <span className="objective-icon">{obj.icon}</span>
                                </div>
                            </div>
                            <div className="objective-content">
                                <h3>{obj.title}</h3>
                                <p>{obj.description}</p>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Bottom Register Button */}
                <div className="objective-bottom-cta">
                    <Link to="/events/global-summit" className="objective-register-btn large">
                        Register Now for AICIS 2026
                    </Link>
                </div>

                {/* Back Button */}
                <div className="activity-back">
                    <Link to="/activities" className="back-button">← Back to Activities</Link>
                </div>
            </div>
        </div>
    );
};

export default Objectives;